// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1roB1","footer":"ModalInfo_footer__-bM_z"};